// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__377W-","Container":"Icon_Container__2S79Q","Contents":"Icon_Contents__3v0ZT"};